// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:10:09

export default {
  "id": "boxteria",
  "slug": "boxteria",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0e685ea680724ba3ba1ca790cd566745-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0e685ea680724ba3ba1ca790cd566745/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Boxteria",
      "description": "Dive into an amazing cubic world, where you can become anyone from a BANDIT to a ZOMBIE attacking everyone around! Imagine having 20 super cool cars at your disposal to ride, drift, and have fun on maps like \"Russian Village,\" and \"Courtyard,\" spaces filled with adventures.\n\nYou'll enjoy creating characters, each unique in their own way. You can assemble a team of bandits, zombies, or even police officers and engage in thrilling battles or cool races.",
      "instructions": "Control on the computer:\n\nShoot \\ Spawn Character (or Car) = \"LMB\" (left mouse button)\n\nSettings - \"Esc\"\n\nSelect Character \\ Car for Spawn - \"Tab\"\n\nScroll through weapons \\ tools - \"Mouse Wheel\"\n\nJump - \"Space\"\n\nGet in the car - \"B\"\n\nStart War - \"V\"\n\nControl on the phone is carried out using the buttons on the screen :)\n\nEnjoy the game!",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "crime",
        "drift",
        "guns",
        "police",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "博克斯特里亚",
      "description": "深入一个令人惊叹的立方世界，在这里你可以成为从强盗到僵尸，攻击周围所有人的角色！想象一下拥有20辆超级酷炫的汽车可供驾驶、漂移，并在“俄罗斯村庄”和“庭院”等充满冒险的地图上玩乐。\n\n你将享受创造角色的过程，每个角色都有其独特之处。你可以组建一支强盗、僵尸或甚至警察队伍，参与刺激的战斗或酷炫的竞速。",
      "instructions": "电脑上的控制：\n\n射击/生成角色（或车辆）= \"左键\"\n\n设置 - \"Esc\"\n\n选择生成角色/车辆 - \"Tab\"\n\n滚动武器/工具 - \"鼠标滚轮\"\n\n跳跃 - \"空格\"\n\n进入车辆 - \"B\"\n\n开始战争 - \"V\"\n\n手机上的控制使用屏幕上的按钮进行 :)\n\n享受游戏！",
      "genres": [
        "射击类游戏"
      ],
      "tags": [
        "犯罪",
        "漂移",
        "枪械",
        "警察",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "波克斯特利亞",
      "description": "投入一個令人驚豔的立方體世界，您可以成為從盜賊到僵尸，攻擊周圍所有人的存在！想像一下擁有20輛超酷的車輛可供騎乘、漂移和享受在「俄羅斯村莊」和「廣場」這樣的地圖上，充滿冒險的空間。\n\n您將享受創建角色，每個角色都有其獨特的特色。您可以組建一支盜賊、僵尸甚至警察的隊伍，並參與刺激的戰鬥或酷炫的賽車。",
      "instructions": "電腦上的控制：\n\n射擊 \\ 生成角色（或車輛）= \"LMB\"（左鍵鼠標）\n\n設定 - \"Esc\"\n\n選擇生成角色 \\ 車輛 - \"Tab\"\n\n滾動通過武器 \\ 工具 - \"滑鼠滾輪\"\n\n跳躍 - \"空格\"\n\n進入車輛 - \"B\"\n\n開始戰爭 - \"V\"\n\n手機上的控制使用螢幕上的按鈕進行 :)\n\n享受遊戲！",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "犯罪",
        "漂移",
        "槍械",
        "警察",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "波克特利亞",
      "description": "跳進一個驚人的立方體世界，你可以成為一個從盜賊到僵屍，攻擊周圍每個人的角色！想像一下擁有20輛超酷的車輛可供駕駛，在「俄羅斯村落」和「廂院」等地圖上漂移、兜風、享受冒險。你將享受創造角色，每個角色都有其獨特的特點。你可以組隊盜賊、僵屍，甚至是警察，參與刺激的戰鬥或酷炫的賽車。",
      "instructions": "電腦控制：\n\n射擊 \\ 生成角色（或車輛）= \"LMB\"（左鍵鼠標）\n\n設定 - \"Esc\"\n\n選擇生成角色 \\ 車輛 - \"Tab\"\n\n滾動通過武器 \\ 工具 - \"滑鼠滾輪\"\n\n跳躍 - \"空格\"\n\n進入車輛 - \"B\"\n\n開始戰爭 - \"V\"\n\n手機控制使用螢幕上的按鈕進行 :) \n\n享受遊戲！",
      "genres": [
        "射手"
      ],
      "tags": [
        "罪行",
        "漂移",
        "槍械",
        "警察",
        "武器"
      ]
    },
    "ja": {
      "title": "ボクステリア",
      "description": "驚異的な立方体の世界に飛び込み、バンドットからゾンビまで、周りの人々を攻撃するどんなキャラクターにもなりたい！20台のスーパーコールな車を所有し、「ロシアの村」や「中庭」といった冒険に満ちたマップで乗り回り、ドリフトや楽しい時間を過ごせることを想像してみよう。\n\nキャラクターを作成するのが楽しく、それぞれがユニークな特徴を持っている。バンドットやゾンビ、警察官など、チームを編成し、スリル満点のバトルやクールなレースに参加できる。",
      "instructions": "コンピュータでの操作：\n\n射撃 \\キャラクター（または車）の生成 = \"LMB\"（左マウスボタン）\n\n設定 - \"Esc\"\n\n生成するキャラクター \\ 車を選択 - \"Tab\"\n\n武器 \\ 工具をスクロール - \"マウスホイール”\n\nジャンプ - \"Space”\n\n車に乗る - \"B”\n\n戦争を始める - \"V”\n\nスマートフォンでの操作は画面のボタンを使用です ：）\n\nゲームを楽しんでください！",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "犯罪",
        "ドライブ",
        "銃",
        "警察",
        "武器"
      ]
    },
    "ko": {
      "title": "박스터리아",
      "description": "惊人한立方형 세계에 뛰어들어, 강도에서 죽이로 각색할 수 있는 다양한 캐릭터가 주위의 모든 사람을 공격할 수 있습니다! \"러시안 비ilage\"와 \"Courtyard\"과 같은 맵에서 20대 강력한 차량을 타고, 드래프트를 하며 즐길 수 있는 상상해 보세요. 모험으로 가득한 공간입니다.\n\n각자 독특한 캐릭터를 만들어보세요. 강도, 죽이, 심지어 경찰관 팀을 꾸려 치열한 전투나 멋진 경주에 참여하세요.",
      "instructions": "컴퓨터에서의 조작:\n\n발사 \\ 캐릭터(또는 자동차) 생성 = \"LMB\" (왼쪽 마우스 버튼)\n\n설정 - \"Esc\"\n\n생성할 캐릭터 \\ 자동차 선택 - \"Tab\"\n\n무기 \\ 도구를 탐색 - \"마우스 휠\"\n\n점프 - \"Space\"\n\n자동차에 진입 - \"B\"\n\n전쟁 시작 - \"V\"\n\n폰에서의 조작은 화면의 버튼을 사용합니다 :)\n\n게임을 즐겨주세요!",
      "genres": [
        "쏘격 게임"
      ],
      "tags": [
        "죄",
        "드래프트",
        "총",
        "경찰",
        "무기"
      ]
    },
    "fr": {
      "title": "Boxteria",
      "description": "Plongez dans un monde cubique incroyable, où vous pouvez devenir tout ce que vous voulez, d'un BANDIT à un ZOMBIE attaquant tout le monde autour ! Imaginez avoir 20 voitures incroyables à votre disposition pour conduire, glisser et vous amuser sur des cartes comme \"Russian Village\" et \"Courtyard\", des espaces remplis d'aventures.\n\nVous apprécierez de créer des personnages, chacun unique à sa manière. Vous pouvez assembler une équipe de bandits, de zombies, ou même de policiers et engager des batailles captivantes ou des courses sympas.",
      "instructions": "Contrôle sur ordinateur :\n\nTirer \\ Créer personnage (ou voiture) = \"Bouton gauche de la souris\"\n\nParamètres - \"Échap\"\n\nSélectionner personnage \\ voiture pour création - \"Tab\"\n\nNaviguer dans les armes \\ outils - \"Roue de la souris\"\n\nSauter - \"Espace\"\n\nMonter dans la voiture - \"B\"\n\nDémarrer la guerre - \"V\"\n\nContrôle sur téléphone : effectué en utilisant les boutons de l'écran :)\n\nProfitez du jeu !",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "crime",
        "drift",
        "armes à feu",
        "police",
        "armes"
      ]
    }
  }
};
